import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {ResetPasswordComponent} from './reset/reset-password.component';
import {ResetPasswordInitComponent} from './reset/reset-password-init.component';
import {AccountCreatedComponent} from './register/account-created.component';
import {LogoutComponent} from './logout/logout.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Account'
    },
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: {
          title: 'Login Page'
        }
      },
      {
        path: 'logout',
        component: LogoutComponent,
        data: {
          title: 'Logout Page'
        }
      },
      {
        path: 'register',
        component: RegisterComponent,
        data: {
          title: 'Register Page'
        }
      }
    ]
  },
  {
    path: 'reset',
    data: {
      title: 'Reset password'
    },
    children: [
      {
        path: 'init',
        component: ResetPasswordInitComponent,
        data: {
          title: 'Init Reset Password'
        }
      },
      {
        path: 'finish',
        component: ResetPasswordComponent,
        data: {
          title: 'Finish Reset Password'
        }
      }
    ]
  },
  {
    path: 'account',
    data: {
      title: 'Account Created'
    },
    children: [
      {
        path: 'created',
        component: AccountCreatedComponent,
        data: {
          title: 'Account Created'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}
